export const animation_header = () => {
    const el_header__svg = document.querySelector('.header__svg');

    if (el_header__svg) {
        const el_Lines = document.querySelectorAll('.line');
        const el_Receipt = document.querySelectorAll('.receipt');
        gsap.set(el_header__svg, { perspective: 50 });
        gsap.set("#semi-circle--right", { x:-1 });

        const tlHeader = gsap.timeline({
            onComplete: () => { tlHeaderLoop.play(); }
        });

        // Define the looping timeline, paused initially
        const tlHeaderLoop = gsap.timeline({ paused: true, repeat: -1, yoyo: true });
        const tlFile = gsap.timeline({ paused: false, delay: 1});

        // Header animation sequence
        tlHeader
            .from([el_header__svg,], 0.5, { scale: 0 }, 0.1, 0)
            .from("#reveal-semi-circle", { duration: 0.7, scale: 0, opacity: 0, rotate: '180deg', transformOrigin: "center center", ease: 'power2.inOut' }, 0.3)
            .to("#semi-circle--left", { duration: 0.7, y: '0px', x: '-2px', transformOrigin: "right center", ease: 'power2.inOut' }, 0.7)
            .to("#semi-circle--right", { duration: 0.7, y: '0px', x: '2px', fill: '#F2F2F2', transformOrigin: "right center", ease: 'power2.inOut' }, 0.8)
            .to("#semi-circle--left", { duration: 0.7, y: '-20px', ease: 'power2.out' }, '-=0.4')
            .to("#semi-circle--right", { duration: 0.7, y: '20px', ease: 'power2.out' }, '-=0.6');

        tlFile.from(el_Receipt, 0.5, { autoAlpha: 0 }, 0.1, 0)
              .from('#check-container', 0.3, { scale: 0, opacity:0, transformOrigin: "center center" }, 0)
              .from('#check', 0.3, { scale: 0, y:10, opacity:0, transformOrigin: "center center" }, 0.4)
              .staggerFrom(el_Lines, 0.7, { scaleX: 0,transformOrigin: "right center", ease: 'power2.Out' }, 0.1, 0.3)

        // Looping animation sequence
        tlHeaderLoop.to("#semi-circle--left", { y: '20px', transformOrigin: "right center", ease: 'none', duration: 1.4 }, 0)
            .to("#semi-circle--right", { y: '-20px', transformOrigin: "left center", ease: 'linear.none', duration: 1.6 }, 0.15);
    }
};

export const animations = () => {
   const tl = gsap.timeline({ repeat: -1, yoyo: true });

    gsap.set("#loading svg", { perspective: 100 });

    tl.fromTo("#loader__left", { y: 3, scale: 0.7, transformOrigin: "right center" }, { duration: 0.7, scale: 0.7, y: -3, transformOrigin: "right center", ease: 'linear.none' }, 0)
        .fromTo("#loader__right", { y: -3, scale: 0.8, transformOrigin: "left center" }, { duration: 0.8, scale: 0.78, y: 2, transformOrigin: "left center", ease: 'linear.none' }, 0.1);

    TweenMax.to("#loading svg", 0.5, { rotation: 180, repeat: -1, transformOrigin: "center center", repeatDelay: 3, delay: 2, ease:'Power3.EaseIn'}, 0);

    animation_header();
};
